/* tslint:disable */
/* eslint-disable */
/* @relayHash 552390cccdc34c18215a1faf9f9e6251 */

import { ConcreteRequest } from "relay-runtime";
export type MeetingPrivacy = "LOCKED" | "LOCKED_LOGGED" | "LOGGED" | "OPEN" | "%future added value";
export type MeetingType = "AUDIO_ONLY" | "LESSON" | "REGULAR" | "WEBINAR" | "%future added value";
export type ScheduleMeetingAsInput = {
    meeting?: MeetingInput | null;
};
export type MeetingInput = {
    attendees?: Array<AttendeeInput | null> | null;
    doNotify?: boolean | null;
    domainId: string;
    dtEnd: string;
    dtStart: string;
    meta?: MeetingMetaInput | null;
    notes?: string | null;
    title: string;
    type?: MeetingType | null;
    userId: string;
};
export type AttendeeInput = {
    email: string;
};
export type MeetingMetaInput = {
    privacy?: MeetingPrivacy | null;
};
export type scheduleMeetingAsMutationVariables = {
    input: ScheduleMeetingAsInput;
};
export type scheduleMeetingAsMutationResponse = {
    readonly scheduleMeetingAs: {
        readonly errors: ReadonlyArray<{
            readonly key: string;
            readonly message: ReadonlyArray<string | null> | null;
            readonly reason: ReadonlyArray<string | null> | null;
        } | null> | null;
        readonly meeting: {
            readonly id: string;
            readonly userId: string;
            readonly domainId: string;
            readonly title: string;
            readonly url: string | null;
            readonly slug: string;
            readonly number: string;
        } | null;
    } | null;
};
export type scheduleMeetingAsMutation = {
    readonly response: scheduleMeetingAsMutationResponse;
    readonly variables: scheduleMeetingAsMutationVariables;
};



/*
mutation scheduleMeetingAsMutation(
  $input: ScheduleMeetingAsInput!
) {
  scheduleMeetingAs(input: $input) {
    errors {
      key
      message
      reason
    }
    meeting {
      id
      userId
      domainId
      title
      url
      slug
      number
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ScheduleMeetingAsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "scheduleMeetingAs",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ScheduleMeetingAsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "InputError",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "key",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "reason",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "meeting",
        "storageKey": null,
        "args": null,
        "concreteType": "Meeting",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "domainId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "slug",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "number",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "scheduleMeetingAsMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "scheduleMeetingAsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "scheduleMeetingAsMutation",
    "id": null,
    "text": "mutation scheduleMeetingAsMutation(\n  $input: ScheduleMeetingAsInput!\n) {\n  scheduleMeetingAs(input: $input) {\n    errors {\n      key\n      message\n      reason\n    }\n    meeting {\n      id\n      userId\n      domainId\n      title\n      url\n      slug\n      number\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'b59190568922974705e9a9b11bfff774';
export default node;
